import { render, staticRenderFns } from "./RegionCreate.vue?vue&type=template&id=766aaa18"
import script from "./RegionCreate.vue?vue&type=script&lang=ts"
export * from "./RegionCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports